import React from "react";
import "./index.scss";
import {strings} from "../../../strings/strings";

export const ContractCheckFooter = () => {

    return (
        <div className={"contract-check-footer"}>
            {strings.check.footer}
        </div>
    )
};
